module.exports = __webpack_public_path__ + "img/26-green.e98d0b0f.svg";